export default __webpack_public_path__ + "static/media/srdicko.b4b5e3e3.jpg";